import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SharedAuthsWarning from 'app/dashboard/components/SharedAuthsWarning';
import { getPrivateAuthsForZap } from 'app/dashboard/Selectors';
import { propifyAuth } from 'app/dashboard/utils/DashboardUtils';

const mapStateToProps = (state, props) => {
  const privateAuths = getPrivateAuthsForZap(props.zapId, state).map(
    propifyAuth
  );
  return {
    ctaText: 'Share Zap',
    description: `
      This Zap uses data from ${privateAuths.length} of your private accounts.
      Moving this Zap to a Shared Folder shares it with your team members and
      allows them to view data associated with these accounts.
    `,
    privateAuths,
    title: 'Share Zap?',
  };
};

const SharedAuthsWarningForZapContainer = connect(mapStateToProps)(
  SharedAuthsWarning
);

SharedAuthsWarningForZapContainer.propTypes = {
  zapId: PropTypes.number.isRequired,
};

export default SharedAuthsWarningForZapContainer;
